import type {
  CreateFeeConfigInput,
  UpdateFeeConfigInput,
  WalletFeeConfigItem,
  WalletFeeConfigListResult,
} from "@/modules/wallet/domain/repo/wallet-fee";
import type { OffsetPageQueryDTO } from "@/shared/contracts/base";
import { config } from "@/shared/lib/config";
import { fetcher } from "@/shared/lib/fetcher";

export type { WalletFeeConfigItem, WalletFeeConfigListResult };

export const walletFeeApi = {
  async list(query: OffsetPageQueryDTO): Promise<WalletFeeConfigListResult> {
    const url = new URL(`${config.apiUrl}/wallet-fee`);
    url.searchParams.set("limit", String(query.limit ?? 20));
    url.searchParams.set("offset", String(query.offset ?? 0));
    if (query.sort) url.searchParams.set("sort", JSON.stringify(query.sort));
    if (query.filters)
      url.searchParams.set("filters", JSON.stringify(query.filters));
    return fetcher.get<WalletFeeConfigListResult>(url.toString());
  },

  async getDetail(id: string): Promise<WalletFeeConfigItem> {
    return fetcher.get<WalletFeeConfigItem>(
      `${config.apiUrl}/wallet-fee/${id}`,
    );
  },

  async create(body: CreateFeeConfigInput): Promise<{ id: string }> {
    return fetcher.post<{ id: string }>(`${config.apiUrl}/wallet-fee`, body);
  },

  async update(
    id: string,
    body: UpdateFeeConfigInput,
  ): Promise<{ ok: boolean }> {
    return fetcher.put<{ ok: boolean }>(
      `${config.apiUrl}/wallet-fee/${id}`,
      body,
    );
  },
};
